import { useQuery } from '@tanstack/react-query';
import _merge from 'lodash/merge';

import { getUsersTrades } from '@arrived/api_v2';
import { TradesQueryFilters, UserId, OfferingTransaction } from '@arrived/models';

import { UseQueryResult, UseQueryOptions, MAX_STALE_TIME } from '../queries.utils';
import { userTradesQueryKeyFn } from './trades.keys';

const defaultFilters = {
  size: 1000,
};

export function useUserTradesQuery(
  userId?: UserId,
  filters?: TradesQueryFilters,
  options?: UseQueryOptions<OfferingTransaction[]>
): UseQueryResult<OfferingTransaction[]> {
  return useQuery(
    userTradesQueryKeyFn(userId!),
    () => (userId ? getUsersTrades(userId, _merge({}, defaultFilters, filters)) : Promise.resolve([])),
    {
      ...options,
      staleTime: options?.staleTime ?? MAX_STALE_TIME,
      enabled: Boolean(userId) && (options?.enabled ?? true),
    }
  );
}
